import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import LocationContainer from '../../components/admin/locaitons/Locaitons';
const Locations = () => {
  return (
    <AdminLayout>
      <LocationContainer />
    </AdminLayout>
  );
};

export default Locations;
